import { CbRichContent } from "__generated__/sanity"
import { FC } from "react"
import { SanityKeyed } from "sanity-codegen"
import { ContentPageContentBlocksCBRichContent } from "./CbRichContent"

type ContentPageContentBlocksProps = {
  blocks: Array<SanityKeyed<CbRichContent>>
}

export const ContentPageContentBlocks: FC<ContentPageContentBlocksProps> = ({
  blocks,
}) => {
  if (blocks.length === 0) {
    return null
  }
  return (
    <div className="flex flex-col gap-4 py-8 sm:gap-8 sm:py-16">
      {blocks.map((block, index) => {
        switch (block._type) {
          case "cbRichContent":
            return (
              <ContentPageContentBlocksCBRichContent {...block} key={index} />
            )
          default:
            return null
        }
      })}
    </div>
  )
}
